<script setup>
import Nav from "../components/layout/NavBar.vue";
import PageFooter from "../components/layout/PageFooter.vue";
import NotificationToast from "../components/utils/NotificationToast.vue";
</script>

<template>
    <div class="flex flex-col w-screen h-screen overflow-auto justify-between">
        <Nav></Nav>
        <slot></slot>
        <NotificationToast />
        <PageFooter />
    </div>
</template>
